import {Flex, Text, Box} from '@chakra-ui/layout';
import {WidgetBoxWrapper} from './widget-box-wrapper';

interface PiecesRemainingProps {
  color: string;
  availablePiecesFromCurrentAssetOffering?: number;
  totalPiecesFromCurrentAssetOffering?: number;
  soldPiecesFromCurrentAssetOffering?: number;
}
export const PiecesRemaining: React.FC<PiecesRemainingProps> = ({
  color,
  availablePiecesFromCurrentAssetOffering,
  totalPiecesFromCurrentAssetOffering,
  soldPiecesFromCurrentAssetOffering,
}: PiecesRemainingProps) => {
  const height = '8px';
  let width = 0;
  let totalPiecesAvailablePercent = 0;
  //   width less than 2% cannot be seen so any percentage
  //   greater than 0 and less that 2 is set to 2%
  if (
    soldPiecesFromCurrentAssetOffering &&
    totalPiecesFromCurrentAssetOffering
  ) {
    width =
      (soldPiecesFromCurrentAssetOffering /
        totalPiecesFromCurrentAssetOffering) *
        100 >
        0 &&
      (soldPiecesFromCurrentAssetOffering /
        totalPiecesFromCurrentAssetOffering) *
        100 <
        2
        ? 2
        : (soldPiecesFromCurrentAssetOffering /
            totalPiecesFromCurrentAssetOffering) *
          100;
  }

  if (
    availablePiecesFromCurrentAssetOffering &&
    totalPiecesFromCurrentAssetOffering
  ) {
    totalPiecesAvailablePercent =
      (availablePiecesFromCurrentAssetOffering /
        totalPiecesFromCurrentAssetOffering) *
      100;
  }

  return (
    <WidgetBoxWrapper>
      <Box p="16px">
        <Flex justifyContent="space-between" width="100%">
          {!!availablePiecesFromCurrentAssetOffering && (
            <Text textStyle="h7">
              {availablePiecesFromCurrentAssetOffering.toLocaleString('en-US')}{' '}
              pieces available
            </Text>
          )}
          <Flex alignItems="flexEnd" justify="center" align="center">
            <Text textAlign="center" textStyle="h6" color={color}>
              {totalPiecesAvailablePercent &&
                `${totalPiecesAvailablePercent.toFixed(1)}%`}
            </Text>
            <Text
              textAlign="center"
              pl="4px"
              textStyle="subh2"
              casing="uppercase"
              color={color}
            >
              remaining
            </Text>
          </Flex>
        </Flex>
        <Box
          borderRadius="9px"
          width="100%"
          bgColor={color}
          height={height}
          mt={1}
        >
          <Box
            height={height}
            borderRadius="9px"
            width={`${width}%`}
            bgColor="tone3"
          />
        </Box>
      </Box>
    </WidgetBoxWrapper>
  );
};
